export const documentFields = [
  { label: "Aadhar Card", key: "upload_aadhar" },
  { label: "PAN Card", key: "upload_pan" },
  { label: "10th Marksheet", key: "upload_tenth" },
  { label: "12th Marksheet", key: "upload_twelth" },
  { label: "Graduation Marksheet", key: "upload_graduation" },
  { label: "Post Graduation Marksheet", key: "upload_post_graduation" },
  { label: "PF", key: "pf_form" },
  { label: "ESI", key: "esi_form" },
  { label: "Pre Experience letter", key: "pre_exp_letter" },
  { label: "Pre Salary letter", key: "pre_sal_letter" },
];
